import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './Truck.module.postcss';

function TruckSocial({ facebook, instagram, twitter, yelp, rating }) {
  let facebookLink = facebook;
  if (facebookLink && !facebookLink.startsWith('http')) {
    facebookLink = 'http://' + facebookLink;
  }

  return (
    <div className={cn(styles.TruckSocial, {
      [styles.TruckSocial__hasYelp]: yelp && rating,
    })}>
      { facebook &&
        <a
          href={facebookLink}
          target="_blank"
          rel="noopener noreferrer"
          className="icon icon-facebook"
          aria-label="Facebook"
        />
      }
      { instagram &&
        <a
          href={`https://www.instagram.com/${instagram}`}
          target="_blank"
          rel="noopener noreferrer"
          className="icon icon-instagram"
          aria-label="Instagram"
        />
      }
      { twitter &&
        <a
          href={`https://twitter.com/${twitter}`}
          target="_blank"
          rel="noopener noreferrer"
          className="icon icon-twitter"
          aria-label="Twitter"
        />
      }
      { yelp &&
        <a
          href={yelp}
          target="_blank"
          rel="noopener noreferrer"
          className="icon icon-yelp"
          aria-label="Yelp"
        />
      }
    </div>
  );
}

TruckSocial.propTypes = {
  facebook: PropTypes.string,
  instagram: PropTypes.string,
  twitter: PropTypes.string,
  yelp: PropTypes.string,
};

export default TruckSocial;
